/* global SERVER_BASE_URL, ZENDESK_HELP_CENTER_URL */
import React, { Component } from 'react'
import q from 'query-string'
import { notification } from 'antd'
import { DEFAULT_ROUTE } from '@constants/routes'
import { getToken } from '@auth/token-service'

class SSOLogin extends Component {
  // /sso-login is reached either as a direct redirect from Zendesk's help
  // center (Zendesk flow) or from the Help Center life-ring appending
  // ?provider=pylon (Pylon flow) — there is no other in-app navigation to this
  // route — so the SSO flow must kick off on initial mount. Previously this
  // lived in componentDidUpdate and only worked because withLDConsumer() forced
  // a re-render once LaunchDarkly flags arrived. PLAT-2687 removed the LD
  // wrapper, which removed the only thing triggering a re-render, which
  // silently broke SSO. componentDidMount makes the dependency explicit — and
  // the Pylon vs Zendesk choice comes from the URL (set where LD is loaded), so
  // it stays independent of LaunchDarkly timing here.
  componentDidMount() {
    const parsed_url = q.parse(this.props.location.search)
    if (parsed_url.provider === 'pylon') {
      this.proceedPylonSso()
      return
    }
    this.proceedZendeskSso(parsed_url)
  }

  proceedPylonSso = async () => {
    // Two flows reach here, distinguished by whether Pylon handed us its own redirect_uri:
    //  - Pylon-initiated (inbound, BOTS-51): Pylon bounces an unauthenticated portal/KB
    //    visitor to our Login URL with ?redirect_uri=<Pylon graph callback>. We authenticate
    //    them here, mint the JWT, and send them back to that redirect_uri with access_token
    //    appended so Pylon lands them where they started, signed in.
    //  - Platform-initiated (in-app life-ring): no redirect_uri — follow the BFF's pre-built
    //    redirect (JWT + org slug + kbUrl → KB landing).
    const redirectUri = q.parse(this.props.location.search).redirect_uri
    try {
      const response = await fetch(SERVER_BASE_URL + '/api/sso/pylon', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'content-type': 'application/json',
        },
      })
      const data = await response.json()
      if (!response.ok) {
        throw new Error(data.error)
      }
      if (redirectUri) {
        const separator = redirectUri.includes('?') ? '&' : '?'
        window.location = `${redirectUri}${separator}access_token=${data.access_token}`
      } else {
        window.location = data.redirect_url
      }
    } catch (error) {
      notification.error({ message: error.message })
      this.props.history.push(`/${DEFAULT_ROUTE}`)
    }
  }

  proceedZendeskSso = async (parsed_url) => {
    try {
      const brand_id = parsed_url.brand_id
      const locale_id = parsed_url.locale_id
      const return_to = parsed_url.return_to
      if (!brand_id || !locale_id || !return_to) {
        throw new Error('SSO Failed: Missing required parameters')
      }
      const response = await fetch(SERVER_BASE_URL + '/api/sso/zendesk-jwt', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'content-type': 'application/json',
        },
      })
      const data = await response.json()
      if (response.ok) {
        this.submitSsoJwtForm(data.jwt, return_to)
      } else {
        throw new Error(data.error)
      }
    } catch (error) {
      notification.error({ message: error.message })
      this.props.history.push(`/${DEFAULT_ROUTE}`)
    }
  }

  submitSsoJwtForm = (jwt, returnTo) => {
    const ssoForm = document.createElement('form')
    ssoForm.method = 'POST'
    ssoForm.action = `${ZENDESK_HELP_CENTER_URL}/access/jwt?return_to=${encodeURIComponent(returnTo)}`

    const jwtInput = document.createElement('input')
    jwtInput.type = 'hidden'
    jwtInput.name = 'jwt'
    jwtInput.value = jwt
    ssoForm.appendChild(jwtInput)

    document.body.appendChild(ssoForm)
    ssoForm.submit()
  }

  render() {
    return <div></div>
  }
}

export default SSOLogin
